import { useEffect } from 'react'
import { useMapStore } from '../../store/mapStore'

// Interactive legend: when a legend category is isolated, grey out every region
// that does NOT match it via a dim overlay layer on the regions source. Generic
// — works for any categorical property (climate, weather_type, hemisphere,
// country_id, ...). Created once, then only its filter/visibility change.
export function useLegendIsolate(map, regionsData) {
  const legendIsolate = useMapStore((s) => s.legendIsolate)

  useEffect(() => {
    if (!map.current || !map.current.getLayer('regions-fill')) return

    if (!map.current.getLayer('legend-dim')) {
      map.current.addLayer({
        id: 'legend-dim',
        type: 'fill',
        source: 'regions',
        layout: { visibility: 'none' },
        paint: { 'fill-color': '#1a1a1a', 'fill-opacity': 0.72 },
      }, 'regions-hover')
    }

    if (legendIsolate && legendIsolate.prop) {
      map.current.setFilter('legend-dim', ['!=', ['get', legendIsolate.prop], legendIsolate.value])
      map.current.setLayoutProperty('legend-dim', 'visibility', 'visible')
    } else {
      map.current.setLayoutProperty('legend-dim', 'visibility', 'none')
    }
  }, [map, legendIsolate, regionsData])
}
